import { formatKrMoney } from '../../../utils';
import ButtonText from '../../../components/button/button-text/ButtonText';
import styles from './cart-item.module.less';
import ConfirmButton from '../../../components/confirm-button/ConfirmButton';

export const IgnorantCartItem = ({ title, price, handleChange, handleDelete }) => {
    return (
        <div className={[styles.item, styles.hideCountButtons].join(' ')}>
            <span className={styles.rewardTitle}>{title}</span>
            <span className={styles.rewardPrice}>{formatKrMoney(price)}</span>
            {handleChange && (
                <ButtonText className={styles.rewardRemove} onClick={handleChange}>
                    Endre
                </ButtonText>
            )}
            {handleDelete && (
                <ConfirmButton
                    className={styles.rewardRemove}
                    title={`Fjern «${title}»?`}
                    message={`Er du sikker på at du vil fjerne «${title}»?`}
                    onClickSuccess={handleDelete}
                    buttonType="text"
                >
                    Fjern
                </ConfirmButton>
            )}
        </div>
    );
};
